module.exports = __webpack_public_path__ + "assets/media/evening.d3ea41b5.mp3";